const Users = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-Users"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-Users"
      viewBox="0 0 62 65"
      width={_width}
      fill="none"
      {...props}
    >
      <path
        d="M23.6631 29.4394C23.4048 29.4123 23.0948 29.4123 22.8106 29.4394C16.6623 29.2228 11.7798 23.9415 11.7798 17.4415C11.7798 10.8061 16.8948 5.4165 23.2498 5.4165C29.579 5.4165 34.7198 10.8061 34.7198 17.4415C34.694 23.9415 29.8115 29.2228 23.6631 29.4394Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42.3925 10.8335C47.4041 10.8335 51.4341 15.0856 51.4341 20.3127C51.4341 25.4314 47.5591 29.6022 42.7283 29.7918C42.5216 29.7647 42.2891 29.7647 42.0566 29.7918"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.7469 39.4335C4.49519 43.821 4.49519 50.971 10.7469 55.3314C17.851 60.3147 29.5019 60.3147 36.606 55.3314C42.8577 50.9439 42.8577 43.7939 36.606 39.4335C29.5277 34.4772 17.8769 34.4772 10.7469 39.4335Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.3784 54.1665C49.2384 53.7603 50.9951 52.9748 52.4417 51.8103C56.4717 48.6415 56.4717 43.4144 52.4417 40.2457C51.0209 39.1082 49.2901 38.3498 47.4559 37.9165"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Users;
